import { FC, ReactNode } from 'react';
import { css } from '@emotion/react';
import { AnimatedBadge } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { AssistantStatusBadge } from '../assistant-status-badge';

export const AssistantTitle: FC<{ children: ReactNode }> = ({ children }) => {
  const { t } = useTranslation('aiOnboarding');
  return (
    <div css={styles.container}>
      <AssistantStatusBadge size={20} />
      {typeof children === 'string' ? <Text size='large'>{children}</Text> : children}
      <AnimatedBadge label={t('Beta')} animated={false} bgColor={theme.colors.indigo50} />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
};
